/* The Originea — occasion redesign: desktop menu panels (Theme settings → Refonte occasions).
   Hover opens with a short close delay (the mega panel sits below the header padding), click toggles for
   touch screens and keyboards (Enter/Space on the button); Escape, tabbing out and outside clicks close. */
(function () {
  const nav = document.querySelector('[data-ov2-nav]');
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll('[data-ov2-item]'));
  const timers = new WeakMap();

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    const trigger = item.querySelector('.ov2-nav__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeOthers(except) {
    items.forEach((other) => {
      if (other !== except) setOpen(other, false);
    });
  }

  items.forEach((item) => {
    const trigger = item.querySelector('.ov2-nav__trigger');

    // Hover is for real mice only: on touch screens >= 990px a tap also fires compatibility mouse events, which
    // would open the panel just before the click toggles it shut again. Touch and keyboard go through `click`.
    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(timers.get(item));
      closeOthers(item);
      setOpen(item, true);
    });

    item.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      timers.set(item, setTimeout(() => setOpen(item, false), 220));
    });

    if (trigger) {
      let pointer = '';
      trigger.addEventListener('pointerdown', (event) => {
        pointer = event.pointerType;
      });
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        // A mouse already opened the panel on hover: a click must not close it again
        const open = pointer === 'mouse' ? true : !item.classList.contains('is-open');
        pointer = '';
        closeOthers(item);
        setOpen(item, open);
      });
    }

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setOpen(item, false);
      if (trigger) trigger.focus();
    });
  });

  document.addEventListener('click', (event) => {
    if (!nav.contains(event.target)) closeOthers(null);
  });
})();

/* Cart drawer "Souvent ajouté" (snippets/originea-cart-addon.liquid) and product page "Complétez avec"
   (sections/originea-complements.liquid): adds the suggested variant and re-renders the drawer with Dawn's own
   renderContents, so the meter, lines and the next suggestion all refresh (and the drawer opens). Delegated, because
   the drawer's HTML is replaced after every cart change. A variant picker in the same card ([data-ov2-compl-variant])
   overrides the button's variant; data-ov2-reco becomes the hidden line property _reco (which module sold what). */
(function () {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ov2-addon]');
    if (!button) return;
    const drawer = document.querySelector('cart-drawer');
    const picker = button.parentElement.querySelector('[data-ov2-compl-variant]');
    const variantId = picker ? picker.value : button.dataset.ov2Addon;
    const staleError = button.parentElement.querySelector('[data-ov2-compl-error]');
    if (staleError) staleError.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const item = { id: variantId, quantity: 1 };
    if (button.dataset.ov2Reco) item.properties = { _reco: button.dataset.ov2Reco };
    fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: drawer ? drawer.getSectionsToRender().map((section) => section.id) : [],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message || '');
        if (!drawer || !state.sections) {
          window.location.href = window.routes.cart_url;
          return;
        }
        // Same as Dawn's product-form.js: an empty drawer hides its item list until is-empty goes (product page,
        // first item)
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        // The product page button stays on the page (the drawer's own is replaced by the re-render)
        button.disabled = false;
        button.removeAttribute('aria-busy');
        // Same signal as Dawn's own add-to-cart, so a cart page underneath refreshes too
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ov2-addon', productVariantId: variantId, cartData: state });
        }
      })
      .catch((error) => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        // Show Shopify's reason (sold out, quantity limit…) next to the button, or in the drawer, instead of leaving
        // the page
        const cardError = button.parentElement.querySelector('[data-ov2-compl-error]');
        if (cardError) {
          cardError.textContent = (error && error.message) || window.cartStrings?.error || '';
          cardError.hidden = false;
          return;
        }
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (!drawer || !errors) {
          window.location.href = window.routes.cart_url;
          return;
        }
        errors.textContent = (error && error.message) || window.cartStrings?.error || '';
      });
  });
})();

/* Collection attribute filter (snippets/originea-attr-filter.liquid). OR inside a group, AND across groups; the
   group is the token prefix ("bot:", "col:"…). Delegated, because Dawn's sort/price filter re-renders the grid. */
(function () {
  function apply(bar) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const selected = {};
    bar.querySelectorAll('[data-ov2-f-token][aria-pressed="true"]').forEach((chip) => {
      const token = chip.dataset.ov2FToken;
      const group = token.split(':')[0];
      (selected[group] = selected[group] || []).push(`|${token}|`);
    });
    const groups = Object.keys(selected);
    let shown = 0;
    grid.querySelectorAll(':scope > li[data-ov2-f]').forEach((item) => {
      const attrs = item.dataset.ov2F;
      const match = groups.every((group) => selected[group].some((needle) => attrs.includes(needle)));
      item.hidden = !match;
      if (match) shown += 1;
    });

    const active = groups.reduce((sum, group) => sum + selected[group].length, 0);
    const badge = bar.querySelector('[data-ov2-filter-active]');
    badge.hidden = active === 0;
    badge.textContent = active ? `(${active})` : '';
    bar.querySelector('[data-ov2-filter-reset]').hidden = active === 0;
    const status = bar.querySelector('[data-ov2-filter-status]');
    status.textContent = active ? (shown === 1 ? status.dataset.one : status.dataset.other).replace('%n', shown) : '';
    const empty = bar.parentElement.querySelector('[data-ov2-filter-empty]');
    if (empty) empty.hidden = !(active && shown === 0);
    const pagination = bar.parentElement.querySelector('.pagination-wrapper');
    if (pagination) pagination.hidden = active > 0;
  }

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-ov2-f-token]');
    const reset = event.target.closest('[data-ov2-filter-reset]');
    if (!chip && !reset) return;
    const bar = event.target.closest('[data-ov2-filter]');
    if (!bar) return;
    if (chip) chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    if (reset) bar.querySelectorAll('[data-ov2-f-token]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
    apply(bar);
  });

  // Open by default on desktop; on phones the bar starts folded under its "Filtrer" summary. Dawn's sort and
  // filters replace #ProductGridContainer (and the bar inside it), so open the new bar again after each re-render.
  function openOnDesktop() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('[data-ov2-filter]').forEach((bar) => (bar.open = true));
  }
  openOnDesktop();
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) new MutationObserver(openOnDesktop).observe(gridContainer, { childList: true });
})();

/* Product page: withdrawal notice that applies to some variants only (sections/main-product.liquid, data-wd-skus).
   Liquid decides per variant; on a variant change Dawn publishes the re-rendered section, and its notice state is
   copied over, so the rule lives in one place. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    const section = document.getElementById(`shopify-section-${data.sectionId}`);
    const current = section ? section.querySelectorAll('[data-wd-skus]') : [];
    const fresh = data.html.querySelectorAll('[data-wd-skus]');
    current.forEach((notice, i) => {
      if (fresh[i]) notice.hidden = fresh[i].hidden;
    });
  });
})();
